import type { FC } from 'react';
import React, { Fragment } from 'react';
import type { ApolloError } from 'apollo-client';
import { defineMessages, FormattedMessage } from 'react-intl-next';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import WarningIcon from '@atlaskit/icon/core/migration/warning';
import { R300, N100 } from '@atlaskit/theme/colors';

import { ErrorDisplay } from '@confluence/error-boundary';

const i18n = defineMessages({
	error: {
		id: 'space-directory.error.message',
		defaultMessage: 'We’re having trouble loading the spaces. Try refreshing the page.',
		description:
			'Shown when Space directory fails to load initially OR fails to load additional spaces',
	},
});

const errorMessageStyle = css({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	marginTop: token('space.250', '20px'),
	color: token('color.text.subtle', N100),
});

export const ErrorMessage: FC<{ apolloError?: ApolloError }> = ({ apolloError }) => (
	<Fragment>
		{apolloError && <ErrorDisplay error={apolloError} />}
		{!apolloError?.extraInfo?.isWatchedError ? (
			<div css={errorMessageStyle}>
				<WarningIcon spacing="spacious" color={token('color.icon.danger', R300)} label="" />
				<FormattedMessage {...i18n.error} />
			</div>
		) : null}
	</Fragment>
);
